import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom' 
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
const ArtCraft = () => {
    useEffect(() => {
        document.title = 'Art & Craft -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Co-Scholastic Dept</li>
                 <li>Art & Craft</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Art & Craft </h1>
                    </div>
                </div>
                <div className="row">
                   <div className="col-lg-12">
                        <p>To suffice the artistic appetite of the young creators, painters and craftsmen, the school building has in itself a spacious art and craft room. Under the able guidance of the Art and Craft teacher, the children undertake many fun-filled projects involving cutting, pasting, drawing and colouring.</p>
                   </div>
                   <div className="col-xl-4 col-lg-4 col-md-6">
    <LazyLoad>
    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/art-and-craft.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/art-and-craft.png" className="schoollib img-fluid" alt="TAFS" /></a> 
    </LazyLoad>  
</div>
<div className="col-xl-4 col-lg-4 col-md-6">
    <LazyLoad>
    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/art-and-craft1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/art-and-craft1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
    </LazyLoad>  
</div>
<div className="col-xl-4 col-lg-4 col-md-6">
    <LazyLoad>
    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/art-and-craft2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/art-and-craft2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
    </LazyLoad>  
</div>
            </div>
            </div>
        </div>
     </>
  )
}

export default ArtCraft